import React from 'react';
import PropTypes from 'prop-types';
import { connect } from '@gasbuddy/react';
import styles from './styles.css';
import ReviewCard from '../review-card';
import Card from '../../card';
import StationPropType from '../../../utils/prop-types/station';
import DateRangePropType from '../../../utils/prop-types/date-range';
import BrandPropType from '../../../utils/prop-types/brand';

const { api, logError } = require('../../../../lib/bputils').default;

class ReviewsFeed extends React.Component {
  static propTypes = {
    station: StationPropType,
    dateRange: DateRangePropType,
    allBrands: PropTypes.arrayOf(BrandPropType),
  }

  static defaultProps = {
    station: null,
    dateRange: null,
    allBrands: null,
  }

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      reviewsCount: null,
      reviews: [],
      reviewsError: false,
    };
  }

  componentDidMount = async () => {
    if (this.props.dateRange) {
      await this.loadReviews();
    }
  }

  componentDidUpdate = async (prevProps) => {
    const { station: { id: stationId }, dateRange: { startDate, endDate } } = this.props;
    if (prevProps.station.id !== stationId
      || prevProps.dateRange?.startDate.format() !== startDate.format()
      || prevProps.dateRange?.endDate.format() !== endDate.format()) {
      await this.loadReviews();
    }
  };

  getStationReviews = async (stationId, startDate, endDate) => {
    const dateRangeQuery = `start_date=${startDate.format('YYYY-MM-DD')}&end_date=${endDate.format('YYYY-MM-DD')}`;
    return api.get({
      path: `/stations/${stationId}/reviews?${dateRangeQuery}`,
      requestId: `stationReviews${dateRangeQuery}`,
    });
  }

  loadReviews = async () => {
    this.setState(() => ({ isLoading: true }));
    const { station: { id: stationId }, dateRange: { startDate, endDate } } = this.props;

    try {
      const { reviews, meta: { total_reviews: reviewsCount } } = await this.getStationReviews(stationId, startDate, endDate);
      this.setState(() => ({ isLoading: false, reviews, reviewsCount }));
    } catch (err) {
      this.setState(() => ({ reviewsError: true }));
      logError(err);
    }
  }

  render = () => {
    const { reviews, reviewsError, reviewsCount } = this.state;
    let { isLoading } = this.state;
    const { allBrands } = this.props;

    // Don't render reviews feed until allBrands prop is loaded
    const brandsMap = _.keyBy(allBrands, 'id');
    if (Object.keys(brandsMap).length === 0) {
      isLoading = true;
    }

    const reviewCountText = reviewsCount ? `(${reviewsCount})` : '';

    return (
      <Card title={`REVIEWS ${reviewCountText}`} isLoading={isLoading} hasError={reviewsError}>
        <div className={styles.reviewListContainer}>
          {reviews.length === 0
          && (
          <div className={styles.noReviews}>
            It looks like you have no current feedback to review.
          </div>
          )}
          {reviews.map(review => (
            <ReviewCard key={review.id} review={review} brandsMap={brandsMap} />
          ))}
        </div>
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  station: state.station,
  dateRange: state.dateRange,
  isLoading: state.loading,
  allBrands: state.brands,
});

export default connect(mapStateToProps, null)(ReviewsFeed);
